import * as React from "react"
import {TextArea, Label, Message} from "semantic-ui-react"
import {isError, getlangFromCache} from "../../../utils"
import {IFormFieldProps} from "."
import ButtonChange from "../buttons/com_button-change"
import ButtonLock from "../buttons/com_button-lock"
import {permanentFormIds} from "../../../models"
import {PreviousValueMessage} from "./form-field-tools"

class View extends React.PureComponent<IFormFieldProps<string>> {
    public handleChange = (event: any) => {
        this.props.onChange({
            code: event.target.name,
            fieldValue: event.target.value,
            lock: this.props.data.lock,
            fieldType: this.props.data.fieldType,
            lang: this.props.lang || getlangFromCache(),
        })
    }

    public render() {
        const {
            label = "",
            data,
            disabled = false,
            onclick,
            onLockClick,
            isNewProduct,
            tabIndex,
            textareaProps,
            formId,
            onModifyClick,
            oldValue,
            ...props
        } = this.props
        const {value, code, errorText, isRequired, lock, fieldType} = data

        const carriageReturns = (value.match(/\n/g) || []).length
        const oldValueCarriageReturns = (
            ((oldValue?.value as string) || "").match(/\n/g) || []
        ).length
        const {rows = 1} = textareaProps || {
            rows: Math.floor(value.length / 130) + 1 + carriageReturns,
        }
        const oldValueRows =
            Math.floor(((oldValue?.value as string) || "").length / 130) +
            1 +
            oldValueCarriageReturns
        const formattedOldValue = oldValue?.value || "N/A"
        return (
            <div className="lock-div" style={{width: "100%"}}>
                {(value || formattedOldValue !== "N/A") && oldValue && `${formattedOldValue}` !== `${value}` ? (
                    <PreviousValueMessage
                        fitted
                        carriaged
                        label={`${oldValue.formattedDate} :`}
                        content={
                            <TextArea
                                autoHeight
                                value={(oldValue?.value as string) || "N/A"}
                                rows={oldValueRows}
                                style={{
                                    width: "100%",
                                    borderRadius: 4,
                                    borderColor: "black",
                                    marginBottom: "1em",
                                    borderStyle: "solid",
                                    borderWidth: 0,
                                }}
                            />
                        }
                    />
                ) : (
                    ""
                )}
                {isError(errorText) ? (
                        <Message
                            className="error-field-message error-textarea-message"
                            negative
                            header={errorText}
                        />
                    )
                    :
                    (
                        ""
                    )
                }
                <div className="pitch-div">
                    <div className="pitch-title" style={{textAlign: "center"}}>
                        <Label
                            style={{
                                width: "150px",
                                textAlign: "right",
                                borderColor: "black",
                                backgroundColor: "inherit",
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                                borderBottomWidth: 0,
                                color: "black",
                                marginTop: "1em",
                            }}
                        >
                            {typeof label === "string"
                                ? label + (isRequired ? "*" : "")
                                : label}
                        </Label>
                        {formId === permanentFormIds.MULTI_MODIF && onModifyClick ? (
                            <ButtonChange
                                modified={data.modified}
                                onClick={onModifyClick}
                                code={code}
                                fieldType={fieldType}
                            />
                        ) : (
                            <ButtonLock
                                hidden={!isNewProduct}
                                lockable={props.lockable}
                                onClick={onLockClick}
                                code={code}
                                lock={lock}
                                fieldType={fieldType}
                            />
                        )}
                    </div>
                    <TextArea
                        {...props}
                        autoFocus={tabIndex === 500}
                        tabIndex={tabIndex}
                        autoHeight
                        rows={rows}
                        value={value}
                        name={code}
                        onChange={this.handleChange}
                        style={{
                            width: "100%",
                            borderRadius: 4,
                            borderColor: "black",
                            marginBottom: "1em",
                            borderStyle: "solid",
                            borderWidth: 1,
                        }}
                        disabled={disabled}
                        onClick={onclick}
                    />
                </div>
            </div>
        )
    }
}

export default View
